"use client";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useMemo } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";
const THU_VI = [
  "Chủ nhật",
  "Thứ hai",
  "Thứ ba",
  "Thứ tư",
  "Thứ năm",
  "Thứ sáu",
  "Thứ bảy",
];

export default function DuDateTabs({ selectedDate, onDateChange }) {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");

  const dateOptions = useMemo(() => {
    const options = [];

    options.push({ value: "live", label: "Trực tuyến", dateLabel: null });

    options.push({ value: todayString, label: "Hôm nay", dateLabel: today.format("DD/MM") });

    const tomorrow = today.clone().add(1, "day");
    options.push({ value: tomorrow.format("YYYY-MM-DD"), label: "Ngày mai", dateLabel: tomorrow.format("DD/MM") });

    for (let i = 2; i <= 6; i++) {
      const d = today.clone().add(i, "day");
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: THU_VI[d.day()],
        dateLabel: d.format("DD/MM"),
      });
    }

    return options;
  }, [today, todayString]);

  const ACTIVE_BTN =
    "h-[60px] w-[90px] flex-none rounded-[10px] border border-white/10 bg-[var(--theme-primary)] px-1 py-2 text-center text-[16px] font-semibold text-[var(--theme-on-primary)] transition hover:brightness-95";
  const INACTIVE_BTN =
    "h-[60px] w-[90px] flex-none rounded-[10px] border border-white/10 du-bg-primary-soft px-1 py-2 text-center text-[16px] font-semibold text-[var(--theme-text)] transition hover:bg-[var(--theme-primary)] hover:text-[var(--theme-on-primary)]";

  return (
    <div className="-mx-4 overflow-x-auto px-4">
      <div className="flex w-max gap-x-2">
      {dateOptions.map((opt) => {
        const isActive = selectedDate === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            aria-pressed={isActive}
            onClick={() => onDateChange?.(opt.value)}
            className={isActive ? ACTIVE_BTN : INACTIVE_BTN}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: 1.1,
            }}
          >
            <div style={{ display: "block" }}>{opt.label}</div>
            {opt.dateLabel ? (
              <div
                className={
                  isActive
                    ? "text-sm font-normal text-[var(--theme-on-primary)]"
                    : "text-sm font-normal text-[var(--theme-text)]"
                }
                style={{ display: "block" }}
              >
                {opt.dateLabel}
              </div>
            ) : (
              <div
                className="text-sm font-normal opacity-0"
                style={{ display: "block" }}
              >
                --
              </div>
            )}
          </button>
        );
      })}
      </div>
    </div>
  );
}
